import { render } from "./SectionEight.vue?vue&type=template&id=3c37cc4a&scoped=true"
import script from "./SectionEight.vue?vue&type=script&lang=js"
export * from "./SectionEight.vue?vue&type=script&lang=js"

import "./SectionEight.vue?vue&type=style&index=0&id=3c37cc4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c37cc4a"]])

export default __exports__